import type { ShippingAddress } from "@stripe/stripe-js";

/** Drops phone from Stripe address payloads; phone belongs on contact, not shipping. */
export function shippingAddressWithoutPhone(
  addr: ShippingAddress,
  name?: string
): ShippingAddress {
  const next = { ...addr } as ShippingAddress & { phone?: string };
  delete next.phone;
  if (next.address && typeof next.address === "object") {
    const a = { ...next.address } as typeof next.address & { phone?: string };
    delete a.phone;
    next.address = a;
  }
  if (name) next.name = name;
  return next;
}
